(function($) {
    'use strict';
    $(window).on('elementor/frontend/init', function() {
        elementorFrontend.hooks.addAction('frontend/element_ready/global', function(scope, $) {

            if ((scope != null) && scope[0].classList.contains('mega__menu')) {

                const $MEGA_BUTTONS = jQuery('.mega__menu .mega__menu--item a')
                const $MEGA_CONTAINERS = jQuery('div.mega__menu--container')
                const MEGA_LINK_SELECTOR = '.mega__menu--item'
                const MEGA_CONTENT_SELECTOR = 'div.mega__menu--container'

                $MEGA_BUTTONS.each((index, element) => {

                    $(element).on('click', (event) => {
                        
                        if (! $(event.currentTarget).hasClass('active')) {
                            event.preventDefault();
                        }

                        let $target = $(event.currentTarget)
                        let $otherButtons  = $target.parents(MEGA_LINK_SELECTOR).siblings(MEGA_LINK_SELECTOR).find('a');
                        let $selectedContentArea  = $target.parents(MEGA_LINK_SELECTOR).next(MEGA_CONTENT_SELECTOR);
                        
                        $(event.currentTarget).addClass('active')
                        $selectedContentArea.addClass('active')
                        
                        $selectedContentArea.siblings(MEGA_CONTENT_SELECTOR).removeClass('active')
                        $otherButtons.removeClass('active')
                    });
                })

                $(document).on('click', (event) => {    
                    /**
                     * Is not button in mega menu. Using .target instead of 
                     * .currentTarget to make it cross browser compatible
                     */
                    if ($(event.target).is('a')) {
                        return
                    }

                    $MEGA_BUTTONS.each((index, element) => {
                        $(element).removeClass('active')
                    })
                    $MEGA_CONTAINERS.each((index, element) => {
                        $(element).removeClass('active')
                    })
                })
            }
        });
    })
})(jQuery);
